import React from "react";
import styled from "styled-components";

export default function ShopifyPayIcon() {
  return (
    <ShopPayIconContainer>
      <ShopPayIcon
        src="//cdn.shopify.com/s/files/1/0257/4522/7828/t/261/assets/shop_pay.png?v=70773351327622069371646143207"
        alt="Shopify Pay"
      />
    </ShopPayIconContainer>
  );
}

const ShopPayIcon = styled.img`
  width: 100%;
`;
const ShopPayIconContainer = styled.div`
  margin-left: auto;
  background-color: white;
  border-radius: 8px;
  width: 96px;
  height: 38px;
  padding: 10px;
  margin-right: 6px;
`;
